const paidItems = [

  // "ncertbook",
  "chapterwisepyq",
  "diagrambasedquestions",
  "flashcard",
  "formula",
  "topernote",
  "mindmap",
  "ncertshortnote",
  // "ncertsolution",
  // "syllabus",
  "dpp",
  "previousyearquestions",
  "quiz",

  "mocktest",
  "previouseyearquiz",
  "topimportantquestions",
  "chapterwisepyq",
  "practicerandomquestion",


]


export default paidItems;
